// import { useCallback, useEffect, useRef } from "react";
// import { DropdownFilterCell } from "./dropdownFIlterCell";
// import ToggleButtonFilterCell from "./toggleButtonFilterCell";
// import { NumericTextBox } from "@progress/kendo-react-inputs";
// import { useDispatch, useSelector } from "react-redux";
// import { setChangedField } from "../../store/Common/actions";

// export const CustomFilterCell = (props) => {
//   const inputRef = useRef(null);
//   const dispatch = useDispatch();
//   const { changedField } = useSelector((state) => state?.CommonReducer);

//   // useEffect(() => {
//   //   debugger;
//   //   if (
//   //     props.value &&
//   //     changedField === props.field &&
//   //     props.customFilterType === "CustomNumericText"
//   //   ) {
//   //     inputRef.current.focus();
//   //   }
//   // }, [props?.value]);

//   const debounce = (func) => {
//     let timer;
//     return function (...args) {
//       const context = this;
//       if (timer) clearTimeout(timer);
//       timer = setTimeout(() => {
//         func.apply(context, args);
//       }, 1000);
//     };
//   };

//   const optimizedVersion = useCallback(
//     debounce((value, syntheticEvent) => {
//       if (props?.customFilterType === "CustomNumericText") {
//         dispatch(setChangedField(props.field));
//         props.onChange({
//           value: value || "",
//           operator: value ? "eq" : "",
//           syntheticEvent: syntheticEvent,
//         });
//       }
//     }),
//     [props.value]
//   );

//   switch (props?.customFilterType) {
//     case "Dropdown":
//       return (
//         <DropdownFilterCell
//           {...props}
//           options={props?.dropdownOptions || []}
//           defaultItem={
//             props?.defaultDropdownOption ? props?.defaultDropdownOption : "All"
//           }
//           selectedVal={props?.value || props?.defaultItem}
//         />
//       );
//     case "Toggle":
//       return (
//         <ToggleButtonFilterCell
//           options={props?.dropdownOptions || []}
//           selectedVal={props?.value || props?.defaultDropdownOption}
//           onChange={props.onChange}
//         />
//       );
//     case "CustomNumericText":
//       return (
//         <div className="k-filtercell-wrapper">
//           <NumericTextBox
//             format="##"
//             value={props.value}
//             ref={inputRef}
//             onChange={(event) => {
//               const { value, syntheticEvent } = event.target;
//               optimizedVersion(value, syntheticEvent);
//             }}
//           />
//         </div>
//       );
//     default:
//       return null;
//   }
// };


import { useCallback, useEffect, useRef, useState } from "react";
import { DropdownFilterCell } from "./dropdownFIlterCell";
import ToggleButtonFilterCell from "./toggleButtonFilterCell";
import { NumericTextBox, TextBox } from "@progress/kendo-react-inputs";
import { useDispatch, useSelector } from "react-redux";
// import { setChangedField } from "../../app/store/Common/actions";


export const CustomFilterCell = (props) => {
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const [localValue,setLocalValue] = useState(props.value);
    const { changedField } = useSelector(
        (state) => state?.CommonReducer
    );

    // useEffect(() => {
    //     if(props.value && changedField === props.field && props.customFilterType === 'CustomNumericText') {
    //         inputRef.current.focus()
    //     }
    // }, [props?.value]);

    const debounce = (func) => {
        let timer;
        return function (...args) {
            const context = this;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(context, args);
            }, 1000);
        };
    };

    const handleFilterChange = useCallback((field, value, operator) => {
        const filtersKey = 'filterState+'+props?.id; // Key to store filters in session storage
        const fieldKey = 'field+'+ props?.id
      
        // Retrieve existing filters from session storage
        const storedFilters = sessionStorage.getItem(filtersKey);
        const parsedFilters = storedFilters ? JSON.parse(storedFilters) : [];

        // Retrieve empty filter field which are previously filled
        const storedFields = sessionStorage.getItem(fieldKey)
        const parsedFields = storedFields ? JSON.parse(storedFields) : [];
      
        let updatedFilters;
        let updatedFields;
      
        if (!value) {
          // If the value is empty, remove the filter for the given field
          updatedFilters = parsedFilters.filter((filter) => filter.field !== field);
          updatedFields = [...parsedFields, field];
          //remove filter from props filter
        } else {
          // If the value is not empty, update or add the filter
          const existingFilter = parsedFilters.find((filter) => filter.field === field);
      
          if (existingFilter) {
            // Update existing filter
            updatedFilters = parsedFilters.map((filter) =>
              filter.field === field
                ? { ...filter, value, operator }
                : filter
            );
          } else {
            // Add new filter
            updatedFilters = [...parsedFilters, { field, value, operator }];
          }
          updatedFields = [...parsedFields].filter((field__item)=>field__item != field);
        }
        // Store updated filters in session storage
        sessionStorage.setItem(filtersKey, JSON.stringify(updatedFilters));
        sessionStorage.setItem(fieldKey, JSON.stringify(updatedFields))
      }, []);
      

    const optimizedVersion = useCallback((value, syntheticEvent,triggerOnChange) => {
        const operator = props.customFilterType === 'CustomNumericText' ? 'eq' : 'contains';

        //if (props?.customFilterType === 'CustomNumericText' || props?.customFilterType === 'CustomTextBox') {
          //  dispatch(setChangedField(props.field))
          handleFilterChange(props.field,value,operator)
          setLocalValue(value);
          if(triggerOnChange==true){
            props.onChange({
                value: value || "",
                operator: value ? operator : "",
                syntheticEvent: syntheticEvent,
            });
          } else if(!value){
            // props.onChange({
            //     value: "",
            //     operator: "",
            //     syntheticEvent: syntheticEvent,
            // });
          }
           
       // }
    }, [props.value,props.customFilterType]);

    switch (props?.customFilterType) {
        case 'Dropdown':
            return <DropdownFilterCell
                {...props}
                options={props?.dropdownOptions || []}
                defaultItem={props?.defaultDropdownOption ? props?.defaultDropdownOption : "All"}
                selectedVal={localValue || props?.defaultItem}
            />;
        case 'Toggle':
            return <ToggleButtonFilterCell
                options={props?.dropdownOptions || []}
                selectedVal={localValue || props?.defaultDropdownOption}
                onChange={props.onChange}
            />;
        case 'CustomNumericText':
            return (
                <div className='k-filtercell-wrapper'
                onKeyDown={(event) => {
                    const { value, syntheticEvent } = event.target;
                   
                    if(event.key === 'Enter'){
                        optimizedVersion(localValue, syntheticEvent,true);
                    }
                   
                }}>
                    <NumericTextBox
                        format="##"
                        value={localValue}
                        ref={inputRef}
                        onChange={(event) => {
                            const { value, syntheticEvent } = event.target;
                            
                            optimizedVersion(value, syntheticEvent);
                        }}
                    />
                </div>
            );
            case 'CustomTextBox':  // String search case using Telerik TextBox
                return (
                    <div className="k-filtercell-wrapper" 
                    //onKeyDown={handleKeyDown}
                    >
                            <TextBox
                                value={localValue}
                                ref={inputRef}
                                //nKeyDown={handleKeyDown}
                                onChange={(event) => {
                                    const { value, syntheticEvent } = event.target;
                                    optimizedVersion(value, syntheticEvent,false);
                                }}
                                onKeyDown={(event) => {
                                    const { value, syntheticEvent } = event.target;
                                   
                                    if(event.key === 'Enter'){
                                        optimizedVersion(localValue, syntheticEvent,true);
                                    }
                                   
                                }}
                               
                                // placeholder="Search..." // Optional placeholder text
                            />
                    </div>
                );	
        default:
            return null;
    }
};